import { render, staticRenderFns } from "./creativity.vue?vue&type=template&id=5e5010ba&scoped=true"
import script from "./creativity.vue?vue&type=script&lang=js"
export * from "./creativity.vue?vue&type=script&lang=js"
import style0 from "./creativity.vue?vue&type=style&index=0&id=5e5010ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5010ba",
  null
  
)

export default component.exports